import { useEffect } from "react";
import { datadogRum } from "@datadog/browser-rum";
import packageJson from "../../package.json";

// Same Datadog RUM application as online-v3-ui (shared applicationId / clientToken / site).
// `service` is "payment" so payment sessions are filterable on their own.
// If a dedicated "payment" RUM app is created in Datadog, swap applicationId/clientToken here.
const env = import.meta.env.VITE_ENV || "";

export default function useDatadogRum() {
  useEffect(() => {
    datadogRum.init({
      applicationId: "dfe47377-2d68-4b8d-abf5-88c38ffe579d",
      clientToken: "pub2f0b89ae4158a3960066fca62015e495",
      site: "us5.datadoghq.com",
      service: "payment",
      env: env,
      version: packageJson.version,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      defaultPrivacyLevel: "allow",
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
    });
  }, []);
}
